const casaideas = {
  // Without Sgs
  RESERVED: {
    HD: {
      order: "Creada"
    },
    SP: {
      order: "Creada"
    },
    RT: {
      order: "Creada"
    }
  },
  PENDING_PREPARATION: {
    HD: {
      order: "Ingresada",
    },
    SP: {
      order: "Ingresada",
    },
    RT: {
      order: "Preparación pendiente",
    }
  },
  // With Sgs
  AWAITING_STORE_CONFIRMATION: {
    HD: {
      sg: "Ingresada",
    },
    SP: {
      sg: "Ingresada",
    },
    RT: {
      sg: "Ingresada",
    }
  },
  PENDING_PACKAGE: {
    HD: {
      sg: "Empacado"
    },
    SP: {
      sg: "Empacado"
    },
    RT: {
      sg: "Empacado"
    }
  },
  IN_TRANSIT: {
    HD: {
      order: "En ruta",
      sg: "En ruta"
    },
    RT: {
      order: "Devolución en ruta",
      sg: "Devolución en ruta"
    }
  },
}

export default casaideas;